import { useEffect, useState } from 'react';
import { useIsMsalAuth, UserRoles } from '@equifinance/shared';
import useApplicationApi from '../../../api/useApplicationApi';

export function useBdmAssignedName(bdmAssigned: string = ''): string {
  const [BdmName, setBdmName] = useState('');
  const { getInternalUsers } = useApplicationApi();
  const isInternalUser = useIsMsalAuth();

  useEffect(() => {
    if (!bdmAssigned) return;
    if (!isInternalUser) return;

    const getBdmAssignedName = async () => {
      const underwriters = await getInternalUsers(UserRoles.BDM);
      const bdm = underwriters?.find((u) => u.id === bdmAssigned);
      setBdmName(bdm?.displayName || '');
    };

    getBdmAssignedName();
  }, [bdmAssigned]);

  return BdmName;
}
